import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Breadcrumb, Dropdown, Space, Table, Button, Drawer, Modal, Tag, Avatar } from 'antd';
import axios from "axios";
import Loading from '../../../Helpers/Loading';

import {
  DownOutlined,
  ExclamationCircleOutlined,
  UserOutlined

} from '@ant-design/icons';
import AddOrUpdateCard from './AddOrUpdateCard';
import Qr from '../../../Helpers/Qr';




export class Card extends Component {




  constructor(props) {
    super(props)


    const items = [
      {
        key: '4',
        label: "Preview",
        danger: true,
      },
      {
        key: '1',
        label: 'Edit',
      },
      {
        key: '2',
        label: 'Enable / Disable',
      },

      {
        key: '3',
        label: "Delete",
        danger: true,
      },

    ];


    this.state = {
      id: 0,
      pagination: {
        current: 1,
        pageSize: 25,
        total: 0
      },
      filterTable: null,
      tableLoading: true,
      pageLoading: false,
      columns: [
        {
          title: 'ID',
          dataIndex: 'num',
          key: 'num',
        },
        {
          title: 'Avatar',
          dataIndex: 'avatar',
          key: 'avatar',
          render: (text) => (
            <>
              {text === "" ?
                <Avatar
                  size={100}
                  icon={<UserOutlined />}
                />
                :
                <Avatar
                  size={100}
                  src={process.env.REACT_APP_ADDRESS + "Assets/upload/" + text}
                />
              }


            </>
          )
        },
        {
          title: 'Name Surname',
          dataIndex: 'name',
          key: 'name',
          render: (text, row) => (
            <>
              {row.sex} {row.name} {row.surname}
            </>
          )
        },
        {
          title: 'E-Business Card',
          dataIndex: 'ebusinessId',
          key: 'ebusinessId',
        },
        {
          title: 'Title',
          dataIndex: 'title',
          key: 'title',
        },
        {
          title: 'QR',
          dataIndex: 'qr',
          key: 'qr',
          render: (text, row) => (
            <>
              <Qr val={window.location.origin + "/Eb/" + row.ebusinessId} size={100} />
            </>
          )
        },

        {
          title: 'Status',
          dataIndex: 'status',
          key: 'status',
          render: (text) => (
            <>
              {text === 1 ?
                <Tag color="blue">Active</Tag>
                :
                <Tag>Passive</Tag>
              }
            </>
          )
        },
        {
          title: 'Actions',
          dataIndex: 'productCode',
          key: 'productCode',
          render: (text, record) => (
            <>
              <Dropdown
                trigger={["click"]}
                menu={{
                  items,
                  onClick: this.handleMenuClick.bind(this, record)
                }}>
                <Button >
                  <Space>
                    Action
                    <DownOutlined />
                  </Space>
                </Button>
              </Dropdown>


            </>
          )

        }
      ],
      tableData: [],
      open: false,
      openPreview: false,
      previewId: ""


    }
  }

  handleMenuClick = (e, b, c) => {

    if (b.key === '3') {
      this.delete(e.id);
    }

    if (b.key === '2') {
      this.changeStatus(e.id);
    }
    if (b.key === "1") {
      this.setState({
        open: true,
        id: e.id
      })
    }


    if (b.key === '4') {

      this.setState({
        openPreview: true,
        previewId: e.ebusinessId
      })

    }



  }


  delete = (id) => {

    Modal.confirm({
      title: 'Confirm',
      icon: <ExclamationCircleOutlined />,
      content: 'Are you sure ?',
      okText: 'Delete',
      cancelText: 'Cancel',
      okType: 'danger',
      onOk: (e) => {
        const data = {
          id: id
        }

        this.setState({
          pageLoading: true,
        });

        axios.post(process.env.REACT_APP_ADDRESS + `Card/deleteItem`, data)
          .then(res => {
            Modal.destroyAll();
            this.setState({
              pageLoading: false,
            })
            this.getDatas();


          });
      }
    });
  }


  changeStatus = (id) => {

    Modal.confirm({
      title: 'Confirm',
      icon: <ExclamationCircleOutlined />,
      content: 'Are you sure ?',
      okText: 'Change Status',
      cancelText: 'Cancel',

      onOk: (e) => {
        const data = {
          id: id
        }

        this.setState({
          pageLoading: true,
        });

        axios.post(process.env.REACT_APP_ADDRESS + `Card/changeStatus`, data)
          .then(res => {
            Modal.destroyAll();
            this.setState({
              pageLoading: false,
            })
            this.getDatas();


          });
      }
    });
  }


  handleTableChange = (a, b, c) => {

    this.setState({
      pagination: a,
      sorters: c

    }, () => {
      this.getDatas();
    })


  }


  componentDidMount() {
    this.getDatas();
  }

  getDatas = () => {
    const data = {
      pagination: this.state.pagination,
      sorters: this.state.sorters,
    }
    axios.post(process.env.REACT_APP_ADDRESS + `Card/getList`, data)
      .then(res => {

        this.setState({
          tableData: res.data.data,
          tableLoading: false,
          pagination: {
            ...this.state.pagination, total: res.data.total
          }
        })
      });
  }



  close = () => {
    this.setState({
      open: false
    });
  }

  add = () => {
    this.setState({
      open: true,
      id: 0
    })
  }

  refresh = () => {
    this.setState({
      open: false,
      id: 0
    }, () => {
      this.getDatas();
    });

  }



  closePreview = () => {
    this.setState({
      openPreview: false
    });
  }





  render() {




    return (
      <>
        {this.state.pageLoading && <Loading />}
        <div className='row'>
          <div className='col-md-12'>
            <Breadcrumb style={{ margin: '16px 0' }}>
              <Breadcrumb.Item>Home</Breadcrumb.Item>
              <Breadcrumb.Item>E-Card</Breadcrumb.Item>
            </Breadcrumb>
          </div>
          <div className='col-md-12'>
            <div className="card">
              <div className="card-body">
                <div className='row mb-3'>
                  <div className='col-md-12 text-end'>
                    <button type="button" onClick={this.add.bind(this)} class="btn btn-primary">Add new item</button>
                  </div>
                </div>
                <div className='row'>
                  <div className='col-md-12'>
                    <Table
                      columns={this.state.columns}
                      dataSource={this.state.filterTable == null ? this.state.tableData : this.state.filterTable}
                      rowKey={"key"}
                      scroll={{ x: 'auto' }}
                      pagination={this.state.pagination}
                      loading={this.state.tableLoading}
                      onChange={this.handleTableChange}

                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
        <Drawer
          title={this.state.id === 0 ? "Create a new item" : "Update item"}
          width={720}
          onClose={this.close.bind(this)}
          open={this.state.open}
          bodyStyle={{ paddingBottom: 80 }}

        >
          {this.state.open &&
            <>
              <AddOrUpdateCard refresh={this.refresh} close={this.close} id={this.state.id} />
            </>
          }
        </Drawer>
        <Drawer
          title="Preview Card"
          width={720}
          onClose={this.closePreview.bind(this)}
          open={this.state.openPreview}
          bodyStyle={{ paddingBottom: 0 }}

        >
          {this.state.openPreview &&
            <>

              <div className="iphone-x">
                <i className="speaker"></i>
                <b className="camera"></b>
                <div className='iphoneBody'>
                  <div className='iphoneContent'>
                    <iframe title="preview" width="100%" height="100%" src={window.location.origin + "/EB/" + this.state.previewId}></iframe>

                  </div>
                </div>
              </div>
            </>
          }
        </Drawer>


      </>
    )
  }
}

const mapStateToProps = (state) => ({})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(Card)